'use client';
import { Button, Stack } from '@mui/material';
import { useState } from 'react';
import dynamic from 'next/dynamic';
import PlaceIcon from '@mui/icons-material/Place';
import Optional from '../../Optional';
import { TestimonialProvider } from './provider';
import { TestimonialInputType } from './type';

const VideoModal = dynamic(
  () => import('./VideoModal').then((c) => c.default),
  {
    ssr: false,
  },
);

type Props = {
  data: TestimonialInputType;
};

const TestimonialInputView = ({ data }: Props) => {
  const [isOpenVideo, setIsOpenVideo] = useState(false);
  const { texts, tenantId, redirect, mode, googleReviewUrl } = data;
  const showVideo = mode !== 'text' && !!tenantId;
  const showGoogle = mode !== 'video' && !!googleReviewUrl;

  return (
    <TestimonialProvider config={{ texts, tenantId, redirect }}>
      <Optional condition={showVideo}>
        <VideoModal open={isOpenVideo} onClose={() => setIsOpenVideo(false)} />
      </Optional>
      <Stack
        spacing={2}
        direction={{ xs: 'column', sm: 'row' }}
        sx={{ justifyContent: 'center', ...data.styling.sx }}
      >
        <Optional condition={showGoogle}>
          <Button
            variant={'outlined'}
            startIcon={<PlaceIcon />}
            component={'a'}
            href={googleReviewUrl}
            target={'_blank'}
            rel={'noopener noreferrer'}
          >
            {texts.buttons.googleReview}
          </Button>
        </Optional>
        <Optional condition={showVideo}>
          <Button variant={'contained'} onClick={() => setIsOpenVideo(true)}>
            {texts.buttons.recordVideo}
          </Button>
        </Optional>
      </Stack>
    </TestimonialProvider>
  );
};

export default TestimonialInputView;
